import { render, staticRenderFns } from "./editdw.vue?vue&type=template&id=1d5ceea4&"
import script from "./editdw.vue?vue&type=script&lang=js&"
export * from "./editdw.vue?vue&type=script&lang=js&"
import style0 from "./editdw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports